import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'

export default function useAreaAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const userData = store.state?.userStore?.userData
  const area = ref({})
  const isSubmitting = ref(false)
  const collection = 'area'

  const create = async (data) => {
    isSubmitting.value = true

    const payload = {
      client_id: oid(userData.client.$oid),
      name: data.name?.value || '',
      areaLeads: data.areaLeads?.value ? data.areaLeads?.value.map(e => oid(e)) : []
    }

    try {
      await createItem({ collection, payload })
      showSuccessMessage(i18n.t('message.area_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.area_add_error'))
    } finally {
      router.push({ name: 'organization-area-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    area,
    isSubmitting,
  }
}
